(function () {
  function getDirectChildrenContainer(item) {
    for (var i = 0; i < item.children.length; i += 1) {
      if (item.children[i].classList.contains('dropdown__family__children')) {
        return item.children[i];
      }
    }
    return null;
  }

  function getFlyoutItems() {
    return Array.from(
      document.querySelectorAll('.header__dropdown .dropdown__family__item')
    ).filter(function (item) {
      return !!getDirectChildrenContainer(item);
    });
  }

  function closeSiblings(currentItem) {
    if (!currentItem.parentElement) return;
    Array.from(currentItem.parentElement.children).forEach(function (child) {
      if (
        child !== currentItem &&
        child.classList &&
        child.classList.contains('dropdown__family__item')
      ) {
        child.classList.remove('is-flyout-open');
      }
    });
  }

  function updateFlyoutDirection(item) {
    var children = getDirectChildrenContainer(item);
    if (!children) return;

    children.classList.remove('flyout--left');
    var rect = children.getBoundingClientRect();
    var viewportWidth = window.innerWidth || document.documentElement.clientWidth;

    if (rect.right > viewportWidth - 12) {
      children.classList.add('flyout--left');
    }
  }

  function openItem(item) {
    closeSiblings(item);
    item.classList.add('is-flyout-open');
    updateFlyoutDirection(item);
  }

  function closeItem(item) {
    item.classList.remove('is-flyout-open');
  }

  function bindFlyouts() {
    var items = getFlyoutItems();
    if (!items.length) return;

    items.forEach(function (item) {
      if (item.dataset.flyoutBound === 'true') return;
      item.dataset.flyoutBound = 'true';

      item.addEventListener('mouseenter', function () {
        if (window.matchMedia('(min-width: 1024px)').matches) {
          openItem(item);
        }
      });

      item.addEventListener('mouseleave', function () {
        if (window.matchMedia('(min-width: 1024px)').matches) {
          closeItem(item);
        }
      });

      item.addEventListener('focusin', function () {
        openItem(item);
      });

      item.addEventListener('focusout', function (event) {
        if (!item.contains(event.relatedTarget)) {
          closeItem(item);
        }
      });
    });
  }

  document.addEventListener('DOMContentLoaded', bindFlyouts);
  document.addEventListener('shopify:section:load', bindFlyouts);
  window.addEventListener('resize', function () {
    getFlyoutItems().forEach(function (item) {
      if (item.classList.contains('is-flyout-open')) {
        updateFlyoutDirection(item);
      }
    });
  });
})();
